// ©2024 Austin App House. All rights reserved.
import React, { useState, useCallback } from 'react';
import ReactQuill from 'react-quill';

const Editor = ({ placeholder, data, onChange, id }) => {
  return (
    <div className='m-2'>
      <ReactQuill 
        id={id}
        theme="snow"
        onChange={onChange}
        defaultValue={data}
        value={data}
        modules={Editor.modules}
        formats={Editor.formats}
        placeholder={placeholder}
      />
    </div>
  );
};

Editor.modules = {
  toolbar: [
    [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
    [{size: []}],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'}, 
     {'indent': '-1'}, {'indent': '+1'}],
    ['link', 'image', 'video'],
    ['clean']
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  }
}

/* 
 * Quill editor formats
 * See https://quilljs.com/docs/formats/
 */
Editor.formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
]

export default Editor;
